import * as React from "react";

export class Row extends React.Component<{}, {}> {
    render() {
        return (
            <div className="rj-racing-future-events__row">{this.props.children}</div>
        )
    }
}